"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthBasic = void 0;
var auth_method_1 = require("./auth.method");
var AuthBasic = (function (_super) {
    __extends(AuthBasic, _super);
    function AuthBasic(user, pass) {
        if (user === void 0) { user = undefined; }
        if (pass === void 0) { pass = undefined; }
        var _this = _super.call(this) || this;
        _this.user = user;
        _this.pass = pass ? btoa(pass) : undefined;
        return _this;
    }
    AuthBasic.prototype.getPass = function () {
        return atob(this.pass);
    };
    AuthBasic.prototype.fromValue = function (value) {
        var basicPieces = value.split(':');
        if (basicPieces.length !== 2) {
            return new Error('basic authorization update expects "user:pass" format, got ' + value);
        }
        this.user = basicPieces[0];
        this.pass = basicPieces[1];
        return undefined;
    };
    AuthBasic.prototype.toValue = function () {
        return 'Basic ' + this.user + ':' + this.pass;
    };
    return AuthBasic;
}(auth_method_1.AuthMethod));
exports.AuthBasic = AuthBasic;
//# sourceMappingURL=auth.basic.js.map